export default {
  order: 9,
  name: "Approvals",
  icon: "mdi-cash-fast",
  to: "/approvals",
  hasSubs: 0,
};
